@import "../../scss";

.root {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto;
  border-radius: 111px;
  background-color: rgba(map-get($theme-colors, "cream"), 0.3);
  user-select: none;
  border: 2px solid var(--color-cream);
  position: relative;
}

.root::after {
  content: "";
  display: block;
  padding-bottom: 100%;
  height: 0;
}

.pad {
  width: 72%;
  height: 72%;
  position: absolute;
  border-radius: 111px;
  background-color: var(--color-cream);
  user-select: none;
  box-shadow: 2px 2px 12px rgba(0, 0, 0, 0.3);
}

.pad::before {
  content: "";
  position: absolute;
  top: -100%;
  left: -100%;
  width: 300%;
  height: 300%;
}
